export const ORDER_HISTORY_REDIRECT = 'order.history.redirect';
export const ORDER_DETAILS_CLICKED = 'order.details.clicked';
export const ORDER_HISTORY_NO_ORDERS_LINK_CLICK = 'order.history.no.orders.link.click';
export type ServiceOrderHistoryEvents = {
    [ORDER_HISTORY_REDIRECT]: undefined;
    [ORDER_DETAILS_CLICKED]: string;
    [ORDER_HISTORY_NO_ORDERS_LINK_CLICK]: undefined;
};
